import dfsSearch from './dfsSearch';
import { JSONSchema, JSONSchemaArray, JSONSchemaObject } from './jsonschemaTypes';
import { MapKey, ObjectMap } from './mapObject';


type JSONSchemaWithMapField = JSONSchema & {
  'map:field'?: MapKey
  'map:array'?: string
}

function parseObjectMapFromSchema(
  schema: JSONSchema,
  initialObjectMap: ObjectMap | Record<string, string> | null | undefined,
  options: {
    removeNullMappedFields?: boolean;
  }
): [MapKey, MapKey][] {
  const objectMap = [];

  const { removeNullMappedFields } = options || {};

  if (initialObjectMap) {
    if (Array.isArray(initialObjectMap)) {
      initialObjectMap.forEach(([mapField, path]) => {
        objectMap.push([mapField, path]);
      });
    } else {
      objectMap.push(...Object.entries(initialObjectMap));
    }
  }

  dfsSearch<[string, JSONSchemaWithMapField, string, any]>([['', schema, '', null]], ([path, current, prop, parent]) => {
    const pathPrefix = path.length ? `${path}.` : '';

    const { type, title, 'map:field': mapField, 'map:array': mapArray } = current;

    if (path && (mapField || mapField === '')) {
      objectMap.push([mapField, path ?? '']);

      if (prop && parent && type === 'null' && title === ' ' && removeNullMappedFields) {
        delete parent[prop];
      }
    }

    switch (current.type) {
      case 'object':
        const objectSchema = current as JSONSchemaObject;
        return Object.entries(objectSchema.properties).map(([prop, propSchema]) => [`${pathPrefix}${prop}`, propSchema, prop, objectSchema.properties]);
      case 'array':
        if (mapArray) {
          const arraySchema = current as JSONSchemaArray;
          const arraySubMap = parseObjectMapFromSchema(arraySchema.items, null, options);

          if (arraySubMap.length === 0) {
            arraySubMap.push(['', '']);
          }

          objectMap.push([mapArray, { array: path, map: arraySubMap }]);
        }

        break;
    }
  });

  return objectMap;
}

export default parseObjectMapFromSchema;
